import { Axios } from "utils";

export const getNotifications = async () => {
  const res = await Axios.get("/v2/portal/Students/notifications");
  return res.data;
};
